"use client";
import { jsx as e } from "react/jsx-runtime";
import { forwardRef as d, createElement as p } from "react";
import c from "../../elements/MultiBox/MultiBox.js";
import { withCmsDataHandling as f } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import u from "../../layout/Container/Container.js";
import x from "../../layout/Section/Section.js";
import { Box as h, sharedHandler as y } from "@ingeniorforeningen/figurine-core";
import { multiBoxesDeliveryApiParser as B } from "./MultiBoxes.helpers.js";
import '../../../assets/MultiBoxes.css';const g = "_grid_gnovm_2", M = {
  grid: g
}, r = d((o, t) => {
  const { items: m, header: s, link: a, ...l } = o;
  return /* @__PURE__ */ e(u, { size: "md", ...l, ref: t, children: /* @__PURE__ */ e(x, { header: s, link: a, children: /* @__PURE__ */ e(h, { className: M.grid, children: m.map((i, n) => /* @__PURE__ */ p(c, { ...i, fluid: !0, key: i.header + n })) }) }) });
});
r.displayName = "MultiBoxes";
const N = f({
  Component: y(r),
  deliveryApiParser: B
});
N.displayName = r.displayName;
export {
  M,
  r as _MultiBoxes,
  N as default
};
